import React from 'react';

import _ from 'lodash';



export interface ITuple {
  loading: boolean;
}

export function useLoading(tuples: ITuple[]) {
  return React.useMemo(() =>
    _.some(tuples, ({ loading }) => loading),
  [tuples]);
}
